import { Helmet } from "@dr.pogodin/react-helmet";
import { useTheme } from "./useTheme";

export const ThemeHelmet = () => {
  const [theme] = useTheme();
  const htmlAttributes: React.HtmlHTMLAttributes<HTMLHtmlElement> & {
    "data-theme": typeof theme;
  } = { "data-theme": theme };

  return <Helmet htmlAttributes={htmlAttributes} />;
};
